// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
import { NextEditorPluginAI } from './aiPlugin';

const aiPlugin = NextEditorPluginAI;
export { aiPlugin };

export type { AIPlugin, AIPluginOptions, AIPluginDependencies } from './aiPluginType';
export type { EditorPluginAIProvider, EditorPluginAISharedState } from './types/types';
export type {
	ADFStreamingInfoAEP,
	ADFStreamingErrorAEP,
	EditorAIAnalyticEventPayload,
} from './types/analytics';
export type { EditorPluginAIActions } from './editor-actions/types';
export type { FAILURE_REASON } from './ui/utils/errors';
export type { Field } from './ui/prebuilt/config-items/prompts/draft-reply/draft-reply';
